import React, { useEffect, useState } from 'react';
import BookOverview from '../../../types/BookOverviewType';
import AdminOverviewTemplate from '../../04_templates/AdminOverviewTemplate/AdminOverviewTemplate';
import useAPI from '../../../hooks/useAPI';

function AdminOverviewPage() {
  const [books, setBooks] = useState<BookOverview[]>();
  const { Get } = useAPI();
  const getBooks = async () => {
    try {
      const data = await Get<BookOverview[]>(`/books`);
      setBooks(data);
    } catch (error) {
      globalThis.dispatchEvent(
        new CustomEvent('ShowAlert', {
          detail: {
            label:
              error instanceof Error
                ? error.message
                : 'Er is een fout opgetreden bij het ophalen van de boeken',
            type: 'Warning',
          },
        }),
      );
    }
  };

  useEffect(() => {
    document.title = 'Sweet Bibi - Admin Overzicht';
    getBooks();
  }, []);

  return (
    <main>
      <AdminOverviewTemplate data={books} />
    </main>
  );
}

export default AdminOverviewPage;

